import { useRef } from 'react';
import { Link } from 'react-router-dom';
import useScrollReveal from '@/hooks/useScrollReveal';

const partners = [
  { name: 'Indian Oil Corporation Ltd.', category: 'Oil Marketing Company', accent: '#F0C808', icon: 'ri-gas-station-fill' },
  { name: 'Bharat Petroleum Corp. Ltd. (BPCL)', category: 'Oil Marketing Company', accent: '#F0C808', icon: 'ri-gas-station-line' },
  { name: 'Hindustan Petroleum Corp. Ltd. (HPCL)', category: 'Oil Marketing Company', accent: '#F0C808', icon: 'ri-oil-line' },
  { name: 'Dept. of Industries, Government of Bihar', category: 'State Government', accent: '#28a99e', icon: 'ri-government-line' },
  { name: 'Ministry of Petroleum & Natural Gas', category: 'Central Government', accent: '#28a99e', icon: 'ri-government-fill' },
  { name: 'Bihar Renewable Energy Dev. Agency (BREDA)', category: 'State Agency', accent: '#008000', icon: 'ri-flashlight-line' },
];

const PartnersSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  useScrollReveal(ref);

  return (
    <section ref={ref} className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-12 md:gap-16">

          {/* Left: label + heading — slides from left */}
          <div>
            <div data-reveal="left" data-delay="1" className="mb-4">
              <span className="text-[11px] font-bold text-bgreen tracking-widest uppercase">03 — Stakeholders</span>
            </div>
            <h2 data-reveal="left" data-delay="2" className="text-3xl md:text-4xl font-bold text-ink leading-tight tracking-tight mb-5">
              Partners &amp;<br />Stakeholders
            </h2>
            <p data-reveal="left" data-delay="3" className="text-ink-muted text-sm leading-relaxed mb-8">
              BEA works with key government bodies, OMCs, and institutions to grow Bihar&apos;s ethanol sector at scale.
            </p>
            <div data-reveal="left" data-delay="4">
              <button
                onClick={() => alert('Coming Soon!')}
                className="inline-flex items-center gap-2 text-sm font-semibold text-ink hover:text-bteal transition-colors duration-150 cursor-pointer"
              >
                View All Partners
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
              </button>
            </div>
          </div>

          {/* Right: partner rows — staggered fade-up */}
          <div>
            {partners.map((p, i) => (
              <div
                key={i}
                data-reveal
                data-delay={String(i + 1)}
                className="flex items-center justify-between gap-4 py-4 border-b border-gray-100 group hover:bg-gray-50 -mx-4 px-4 rounded-lg transition-colors duration-150"
              >
                <div className="flex items-center gap-3">
                  <span
                    className="w-7 h-7 flex items-center justify-center rounded-md flex-shrink-0"
                    style={{ backgroundColor: `${p.accent}18` }}
                  >
                    <i className={`${p.icon} text-xs`} style={{ color: p.accent }} />
                  </span>
                  <p className="font-medium text-ink text-sm">{p.name}</p>
                </div>
                <span
                  className="text-[10px] font-semibold px-2 py-1 rounded-sm whitespace-nowrap flex-shrink-0"
                  style={{ color: p.accent, backgroundColor: `${p.accent}12` }}
                >
                  {p.category}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
